import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

import { renderInstructorPage } from './-route-wrappers';

const ScormReports = lazyRouteComponent(() =>
  import('@/_instructor/scorm-reports').then((module) => ({ default: module.ScormReports }))
);

export const Route = createFileRoute('/_instructor/scorm-reports/$id')({
  component: () => renderInstructorPage(ScormReports),
});
